"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Results;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _siteSearchContext = require("./site-search-context");
var _spinner = _interopRequireDefault(require("../../elements/other/spinner"));
var _resultsList = _interopRequireDefault(require("./results-list"));
var _noResults = _interopRequireDefault(require("./no-results"));
var _searchHeadline = _interopRequireDefault(require("./search-headline"));
var _filterNav = _interopRequireDefault(require("./filter-nav"));
var _filterNavContent = _interopRequireDefault(require("./filter-nav-content"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function Results({
  title,
  headlineTemplate,
  filterNav,
  categorySections,
  headline
}) {
  const {
    searchValue,
    isLoading,
    results
  } = (0, _react.useContext)(_siteSearchContext.SiteSearchContext);
  const noDataAvailable = results === null || results?.length === 0;
  if (isLoading) {
    return /*#__PURE__*/_react.default.createElement(_spinner.default, {
      size: "lg"
    });
  }
  if (!isLoading && !searchValue) {
    return /*#__PURE__*/_react.default.createElement(_resultsList.default, {
      title: title
    });
  }
  if (!isLoading && noDataAvailable) {
    return /*#__PURE__*/_react.default.createElement(_noResults.default, {
      headline: headline
    });
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_searchHeadline.default, {
    headlineTemplate: headlineTemplate
  }), /*#__PURE__*/_react.default.createElement(_filterNav.default, filterNav), /*#__PURE__*/_react.default.createElement(_filterNavContent.default, {
    sections: categorySections
  }));
}
Results.propTypes = {
  title: _propTypes.default.string,
  headlineTemplate: _propTypes.default.string,
  filterNav: _propTypes.default.object,
  categorySections: _propTypes.default.array,
  headline: _propTypes.default.string
};